import condense from 'no-whitespace';

const imageName = (name) => {
  const jpegs = [
    'FloridaArts',
    'FallenLawEnforcementOfficers',
    'StopChildAbuse',
  ];

  let prefix = 'png';
  const clean = name.replace(/[^\w+]/igm, '');

  if (jpegs.indexOf(clean) > -1) {
    prefix = 'jpg';
  }

  return `${condense(clean)}.${prefix}`;
};

export default imageName;



// WEBPACK FOOTER //
// ./src/modules/getPlateImageFromPlateName.js